// Admin data layer (team-centric). Cookie-session-authed (credentials:'include').
export interface TeamRow { teamId: string; name: string; ownerEmail: string | null; storageUsedBytes: number; storageLimitBytes: number; memberCount: number; }
export interface TeamMember { userId: string; email: string; role: string; deactivated?: boolean; }
export interface TeamShare { id: string; songName: string | null; sizeBytes: number | null; createdAt: string; }
export interface TeamDetail { team: { id: string; name: string }; storageUsedBytes: number; storageLimitBytes: number; members: TeamMember[]; shares: TeamShare[]; }
export type TeamsResult = { ok: true; teams: TeamRow[] } | { ok: false; unauthorized?: boolean };
export type TeamDetailResult = { ok: true; detail: TeamDetail } | { ok: false; unauthorized?: boolean };

export async function fetchTeams(apiBase = '', fetchImpl: typeof fetch = fetch): Promise<TeamsResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/admin/teams`, { credentials: 'include' });
    if (res.status === 401 || res.status === 403) return { ok: false, unauthorized: true };
    if (!res.ok) return { ok: false };
    return { ok: true, teams: await res.json() as TeamRow[] };
  } catch { return { ok: false }; }
}
export async function fetchTeamDetail(teamId: string, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<TeamDetailResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/admin/team/${teamId}`, { credentials: 'include' });
    if (res.status === 401 || res.status === 403) return { ok: false, unauthorized: true };
    if (!res.ok) return { ok: false };
    return { ok: true, detail: await res.json() as TeamDetail };
  } catch { return { ok: false }; }
}
async function send(method: string, path: string, body: unknown | undefined, apiBase: string, fetchImpl: typeof fetch): Promise<boolean> {
  try {
    const init: RequestInit = { method, credentials: 'include' };
    if (body !== undefined) { init.headers = { 'content-type': 'application/json' }; init.body = JSON.stringify(body); }
    return (await fetchImpl(`${apiBase}${path}`, init)).ok;
  } catch { return false; }
}
export function setTeamQuota(teamId: string, limitBytes: number | null, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<boolean> {
  return send('POST', '/api/admin/team-quota', { teamId, limitBytes }, apiBase, fetchImpl);
}
export function revokeShare(shareId: string, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<boolean> {
  return send('POST', '/api/admin/revoke-share', { shareId }, apiBase, fetchImpl);
}
export function deactivateUser(userId: string, deactivated: boolean, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<boolean> {
  return send('POST', '/api/admin/deactivate-user', { userId, deactivated }, apiBase, fetchImpl);
}
export function removeMember(teamId: string, userId: string, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<boolean> {
  return send('DELETE', `/api/admin/teams/${teamId}/members/${userId}`, undefined, apiBase, fetchImpl);
}
